import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { MainCardProps } from '../../../models/mainCardProps';

const headerSX = {
  '& .MuiCardHeader-action': { mr: 0 }
};

const MainCard = forwardRef<HTMLDivElement, MainCardProps>(
  (
    {
      border = true,
      boxShadow = false,
      children,
      content = true,
      contentClass = '',
      contentSX = {},
      darkTitle = false,
      secondary = null,
      shadow = '0 2px 14px 0 rgb(32 40 45 / 8%)',
      sx = {},
      title = null,
      ...others
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Card
        ref={ref}
        {...others}
        sx={{
          border: border ? `1px solid ${theme.palette.divider}` : 'none',
          borderColor: border ? theme.palette.primary.main : 'transparent',
          ':hover': {
            boxShadow: boxShadow ? shadow : 'inherit'
          },
          ...sx
        }}
      >
        {title && (
          <CardHeader
            sx={headerSX}
            title={darkTitle ? <Typography variant="h3">{title}</Typography> : title}
            action={secondary}
          />
        )}
        {title && <Divider />}
        {content ? (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        ) : (
          children
        )}
      </Card>
    );
  }
);

export default MainCard;